export const PAGE_UPDATE_DISPLAY_SETTINGS =
  'REPORTING_PAGE_UPDATE_DISPLAY_SETTING';

export const updateDisplaySettings = (newData, pageId, sectionId) => ({
  type: PAGE_UPDATE_DISPLAY_SETTINGS,
  newData,
  pageId,
  sectionId,
});
